import { exportTemplatesFactory } from '@eas/common-web';
import { ExportTag } from '../../../enums';

export const ExportTemplates = exportTemplatesFactory({
  exportTag: ExportTag.EXPORT_TEMPLATES_GRID,
  enableDocx4j: true,
});
